import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'ng2-toastr';
import { AlertService } from './alert.service';
import { ModalService } from './modal.service';
import { ObjectFieldService } from '../settings/object-field.service';

@NgModule({
  imports: [
    ToastModule.forRoot(),
    CommonModule
  ],
  declarations: [],
  providers: [
    AlertService,
    ModalService,
    ObjectFieldService
  ]
})
export class CoreModule {
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts